import Vue from 'vue'

import store from './config/store'
import router from './config/router'
import { sync } from 'vuex-router-sync'

import Root from './components/Root'
import registerFilters from './config/registerFilters'
import registerComponents from './config/registerComponents'
import VueScrollTo from 'vue-scrollto'

import VuePaginate from 'vue-paginate'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  lazyComponent: true
})

registerComponents(Vue)
registerFilters(Vue)
Vue.use(VuePaginate)
Vue.use(VueScrollTo)

sync(store, router)

const app = new Vue({
  router,
  store,
  ...Root
})

export {app, router, store}



// WEBPACK FOOTER //
// ./src/app/index.js